import config from './config.json';

export const { REACT_APP_BUCKET_URL } = config;
export const { REACT_APP_TRACKING_CODE } = config;
export const { REACT_APP_BUILD_NUMBER } = config;
export const { REACT_APP_API_URL } = config;
export const { GOOGLE_MAPS_API_TOKEN } = config;
